import { render, staticRenderFns } from "./InstallationDetail_TerminalStatus.vue?vue&type=template&id=ef5167ec&scoped=true&"
import script from "./InstallationDetail_TerminalStatus.vue?vue&type=script&lang=js&"
export * from "./InstallationDetail_TerminalStatus.vue?vue&type=script&lang=js&"
import style0 from "./InstallationDetail_TerminalStatus.vue?vue&type=style&index=0&id=ef5167ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef5167ec",
  null
  
)

export default component.exports